module.exports = __webpack_public_path__ + "img/Asset-2012-100.e7cd6d7c.jpg";